import { useTranslation } from 'react-i18next';

import { SewBillingCycleRangeExport } from '@/backoffice/features/data-exports/sew-billing-cycle-range-export/sew-billing-cycle-range-export';
import { useLazySewCreditConsumptionExportQuery } from '@/backoffice/redux/api/billing-backoffice/billing-backoffice-api';
import { BillingIcon } from '@/shared/assets/icons/billing-icon';

export const SewCreditConsumptionExport = () => {
  const { t } = useTranslation();
  const [getFile] = useLazySewCreditConsumptionExportQuery();

  const fetchExport = async (
    startBillingCycleReferenceTs: number,
    endBillingCycleReferenceTs: number,
  ) => {
    const response = await getFile({
      startBillingCycleReferenceTs,
      endBillingCycleReferenceTs,
    }).unwrap();
    return response?.sewSdaCreditConsumptionExport;
  };

  return (
    <SewBillingCycleRangeExport
      icon={<BillingIcon />}
      title={t('backoffice:sew.data_exports.credit_consumption.title')}
      description={t(
        'backoffice:sew.data_exports.credit_consumption.description',
      )}
      loaderText={t(
        'backoffice:sew.data_exports.credit_consumption.loader_text',
      )}
      baseFileNamePrefix="sew_credit_consumption_export"
      fetchExport={fetchExport}
    />
  );
};
